import React from "react";

import SummaryCard from "./../../components/SummaryCard/SummaryCard";
import LinearLoader from "./../../components/LinearLoader/LinearLoader";
import UnitsTable from "./../../components/UnitsTable/UnitsTable";
import DatetimePicker from "./../../components/DatetimePicker/DatetimePicker";
import GrowTransition from "./../../components/GrowTransition/GrowTransition";
import { buildErrorCodesColumns } from "./builders";
import {
  Paper,
  Grid,
  Button,
  Typography,
  Switch,
  FormControlLabel,
  FormGroup
} from "material-ui";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import Input, { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import Sequence from "./../../utilities/sequence";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import IconButton from "material-ui/IconButton";
import CloseIcon from "material-ui-icons/Close";
import Slide from "material-ui/transitions/Slide";

import FetchButton from "../../components/FetchButton/FetchButton";
import { Redirect } from "react-router-dom";
import FilterTable from "../../components/FilterTable/FilterTable";
import ScanTimeSeries from "./../../charts/ScanTimeseries/ScanTimeseriesAmcharts";
import TagSelector from "../../components/TagSelector/TagSelector";
import DownloadAs from "../../components/DownloadAs/DownloadAs";
import MediaCard from "./../../components/MediaCard/MediaCard";
import SummaryTripsImage from "./../../images/driving/summary-trips.png";
import SummarySpeedImage from "./../../images/driving/summary-speed.png";
import MinMaxMedCard from "./MinMedMaxCard";
import AlertMessage from "../../components/AlertMessage/AlertMessage";
import ThrottlePositionIcon from "../../images/scan/ThrottlePositionIcon.svg";
import EngineSpeedIcon from "../../images/scan/EngineSpeedIcon.svg";
import SpeedUnitIcon from "../../images/scan/SpeedUnitIcon.svg";
import TemperatureIcon from "../../images/scan/TemperatureIcon.svg";
import RedDTCIcon from "../../images/scan/RedDTCIcon.svg";
import GreenDTCIcon from "../../images/scan/GreenDTCIcon.svg";
import AntifreezeTemperatureIcon from "../../images/scan/AntifreezeTemperatureIcon.svg";
import OilPresureIcon from "../../images/scan/OilPresureIcon.svg";
import OilTemperatureIcon from "../../images/scan/OilTemperatureIcon.svg";
import VehicleBatteryIcon from "../../images/scan/VehicleBatteryIcon.svg";
import HourmeterIcon from "../../images/scan/HourmeterIcon.svg";
import ThrottleChart from "../../charts/ScanTimeseries/ThrottleChart";
import AntifreezeTemperatureChart from "../../charts/ScanTimeseries/AntifreezeTemperatureChart";
import EngineSpeedChart from "../../charts/ScanTimeseries/EngineSpeedChart";
import VehicleSpeedChart from "../../charts/ScanTimeseries/VehicleSpeedChart";

import FuelPerformanceCardImage from "../../images/scan/FuelPerformanceCard.svg";
import OdometerCardImage from "../../images/scan/OdometerCard.svg";
import DeadTimeCardImage from "../../images/scan/DeadTimeCard.svg";
import FuelConsumedCardImage from "../../images/scan/FuelConsumedCard.svg";

import "react-table/react-table.css";
import "./Scan.css";

const ScanView = props => {
  const {
    lang,
    reportData,
    units,
    isLoading,
    permissions,
    loadedPermissions,
    hasData,
    fetchData,
    downloadExcel,
    downloadPDF,
    openConfiguration,
    closeConfiguration,
    isAlertMessageOpen,
    handleCloseAlertMessage,
    saveConfiguration,
    alertMessage,
    defaultConfigurationValues,
    resetConfigurationValues,
    onChangeRangesInputs,
    onChangeRangesCheck,
    onBlurInputConfiguration,
    isConfigOpen,
    dtcRequest,
    toggleDtcRequest,
    selectedRanges,
    chartCardsValues,
    scanChartCursorCallback

    //downloadScanXls
  } = props;

  const errorCodesColumns = buildErrorCodesColumns(lang);

  const sequence = new Sequence(0, 50);
  const duration = 50;

  let data;
  let errorCodes;
  if (hasData) {
    data = reportData.Resultados[0];
    errorCodes = reportData.Resultados.reduce((acum, r) => {
      acum.concat(r.RCodigosError);
      return acum;
    }, []);
  }

  return (
    <div className="scan">
      {loadedPermissions && !permissions.ConsultaCan && (
        <Redirect to={"./"} push />
      )}
      {isLoading && <LinearLoader />}(
      <div className="root">
        <Grid container spacing={24}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="grid-item"
          >
            <DownloadAs
              disabled={!(hasData && !isLoading)}
              xls={true}
              pdf={false}
              xlsClick={downloadExcel}
              pdfClick={downloadPDF}
            />
            <Button
              style={{ marginBottom: "0.5rem" }}
              className="set-values-button"
              color="primary"
              variant="raised"
              onClick={openConfiguration}
            >
              {lang.ConfigurarValores}
            </Button>
            <TagSelector />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="grid-item"
          >
            {dtcRequest && <UnitsTable units={units} />}
            {!dtcRequest && <UnitsTable units={units} singleSelect />}
          </Grid>
        </Grid>
      </div>
      <div className="root">
        <Paper className="summary rounded" elevation={4}>
          <Grid container spacing={24}>
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
              <DatetimePicker />
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <div className="dtc-selection-switch">
                <Switch checked={dtcRequest} onChange={toggleDtcRequest} />
                Solo DTC
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <div className="fetch-button-container">
                <FetchButton
                  disabled={isLoading}
                  onClick={fetchData}
                  text={lang.Consultar}
                />
              </div>
            </Grid>
          </Grid>
        </Paper>
      </div>
      {hasData && reportData.Resultados.length == 1 && (
        <div className="root">
          <Grid container spacing={24}>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              item
              className="grid-item"
            >
              <Typography
                variant="headline"
                align="center"
                color="primary"
                className="headline"
                style={{ marginTop: "1.5rem" }}
              >
                {lang.Resumen}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="grid-item"
            >
              <Paper className="summary rounded" elevation={4}>
                <Grid container spacing={8}>
                  <GrowTransition
                    in={!isLoading}
                    delay={sequence.next()}
                    duration={duration}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.VelocidadMaxima}
                        value={data.VelocidadMaxima}
                        units="km/h"
                        imageUrl={SummarySpeedImage}
                      />
                    </Grid>
                  </GrowTransition>
                  <GrowTransition
                    in={!isLoading}
                    delay={sequence.next()}
                    duration={duration}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.VelocidadPromedio}
                        value={data.VelocidadPromedio}
                        imageUrl={SummarySpeedImage}
                        units="km/h"
                      />
                    </Grid>
                  </GrowTransition>

                  <GrowTransition
                    in={!isLoading}
                    delay={sequence.next()}
                    duration={duration}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.DistanciaRecorrida}
                        value={
                          typeof data.DistanciaRecorrida !== "undefined"
                            ? data.DistanciaRecorrida
                            : "N/A"
                        }
                        units="km"
                        imageUrl={SummaryTripsImage}
                      />
                    </Grid>
                  </GrowTransition>
                  <GrowTransition
                    in={!isLoading}
                    delay={sequence.next()}
                    duration={duration}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      lg={3}
                      xl={3}
                      className="grid-item"
                    >
                      <SummaryCard
                        title={lang.TiempoMovimiento}
                        value={data.TiempoMovimiento.split("(")[0]}
                        imageUrl={SummaryTripsImage}
                        // units="km"
                      />
                    </Grid>
                  </GrowTransition>
                </Grid>
              </Paper>
            </Grid>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              item
              className="grid-item"
            >
              <Grid container>
                <Grid
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  xl={3}
                  item
                  className="grid-item"
                >
                  <MediaCard
                    title={lang.CombustibleUtilizado}
                    imageUrl={FuelConsumedCardImage}
                    imageTitle={""}
                    value={
                      typeof data.CombustibleUtilizado !== "undefined"
                        ? data.CombustibleUtilizado
                        : "N/A"
                    }
                    units={`l`}
                    backgroundColor="transparent"
                    className="media-scan"
                  />
                </Grid>
                <Grid
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  xl={3}
                  item
                  className="grid-item"
                >
                  <MediaCard
                    title={lang.Rendimiento}
                    imageUrl={FuelPerformanceCardImage}
                    imageTitle={""}
                    value={
                      typeof data.Rendimiento !== "undefined"
                        ? data.Rendimiento
                        : "N/A"
                    }
                    units={`km/l`}
                    backgroundColor="transparent"
                    className="media-scan"
                  />
                </Grid>
                <Grid
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  xl={3}
                  item
                  className="grid-item"
                >
                  <MediaCard
                    title={lang.TiempoMuerto}
                    imageUrl={DeadTimeCardImage}
                    imageTitle={""}
                    value={data.TiempoMuerto.split("(")[0]}
                    units={``}
                    backgroundColor="transparent"
                    className="media-scan"
                  />
                </Grid>
                <Grid
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  xl={3}
                  item
                  className="grid-item"
                >
                  <MediaCard
                    title={lang.Odometro}
                    imageUrl={OdometerCardImage}
                    imageTitle={""}
                    value={
                      typeof data.Odometro !== "undefined"
                        ? data.Odometro
                        : "N/A"
                    }
                    units={`km`}
                    backgroundColor="transparent"
                    className="media-scan"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              item
              className="grid-item"
            >
              <Typography
                style={{ marginTop: "1.5rem" }}
                variant="headline"
                align="left"
                color="primary"
                className="headline"
              >
                {lang.Grafica}
              </Typography>
            </Grid>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              item
              className="grid-item"
            >
              <Paper style={{ height: "20rem" }} className="rounded">
                <ScanTimeSeries
                  cursorCallback={scanChartCursorCallback}
                  speedUnit={"Km"}
                  lang={lang}
                  data={data.Ubicaciones}
                />
              </Paper>
            </Grid>
            {/* <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              item
              className="grid-item"
            >
              <Grid container>
                <Grid
                  xs={12}
                  sm={3}
                  md={3}
                  lg={3}
                  xl={3}
                  item
                  className="grid-item"
                >
                  <Paper className="rounded" style={{ height: "14rem" }}>
                    <ThrottleChart
                      lang={lang}
                      value={chartCardsValues.throttlePosition}
                    />
                  </Paper>
                </Grid>
                <Grid
                  xs={12}
                  sm={3}
                  md={3}
                  lg={3}
                  xl={3}
                  item
                  className="grid-item"
                >
                  <Paper className="rounded" style={{ height: "14rem" }}>
                    <AntifreezeTemperatureChart
                      lang={lang}
                      value={chartCardsValues.antifreezeTemperature}
                    />
                  </Paper>
                </Grid>
                <Grid
                  xs={12}
                  sm={3}
                  md={3}
                  lg={3}
                  xl={3}
                  item
                  className="grid-item"
                >
                  <Paper className="rounded" style={{ height: "14rem" }}>
                    <AntifreezeTemperatureChart
                      lang={lang}
                      value={chartCardsValues.engineSpeed}
                    />
                  </Paper>
                </Grid>
                <Grid
                  xs={12}
                  sm={3}
                  md={3}
                  lg={3}
                  xl={3}
                  item
                  className="grid-item"
                >
                  <Paper className="rounded" style={{ height: "14rem" }}>
                    <ThrottleChart
                      lang={lang}
                      value={chartCardsValues.throttlePosition}
                    />
                  </Paper>
                </Grid>
              </Grid>
            </Grid> */}
            {data.TemperaturaAnticongelante.Valida && (
              <Grid
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={4}
                item
                className="grid-item"
              >
                <MinMaxMedCard
                  icon={AntifreezeTemperatureIcon}
                  lang={lang}
                  title={lang.TemperaturaAnticongelante}
                  units="°C"
                  minMaxMed={data.TemperaturaAnticongelante}
                  inProp={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                />
              </Grid>
            )}
            {data.VelocidadMotor.Valida && (
              <Grid
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={4}
                item
                className="grid-item"
              >
                <MinMaxMedCard
                  icon={EngineSpeedIcon}
                  lang={lang}
                  title={lang.VelocidadMotor}
                  units="RPM"
                  minMaxMed={data.VelocidadMotor}
                  inProp={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                />
              </Grid>
            )}
            {data.VelocidadVehiculo && (
              <Grid
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={4}
                item
                className="grid-item"
              >
                <MinMaxMedCard
                  icon={SpeedUnitIcon}
                  lang={lang}
                  title={lang.VelocidadVehiculo}
                  units="km/h"
                  minMaxMed={data.VelocidadVehiculo}
                  inProp={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                />
              </Grid>
            )}
            {data.TemperaturaCabina.Valida && (
              <Grid
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={4}
                item
                className="grid-item"
              >
                <MinMaxMedCard
                  icon={TemperatureIcon}
                  lang={lang}
                  title={lang.TemperaturaCabina}
                  units="°C"
                  minMaxMed={data.TemperaturaCabina}
                  inProp={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                />
              </Grid>
            )}
            {data.PosicionAcelerador.Valida && (
              <Grid
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={4}
                item
                className="grid-item"
              >
                <MinMaxMedCard
                  icon={ThrottlePositionIcon}
                  lang={lang}
                  title={lang.PosicionAcelerador}
                  units="%"
                  minMaxMed={data.PosicionAcelerador}
                  inProp={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                />
              </Grid>
            )}
            {data.BateriaVehiculo.Valida && (
              <Grid
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={4}
                item
                className="grid-item"
              >
                <MinMaxMedCard
                  icon={VehicleBatteryIcon}
                  lang={lang}
                  title={lang.BateriaVehiculo}
                  units="V"
                  minMaxMed={data.BateriaVehiculo}
                  inProp={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                />
              </Grid>
            )}
            {data.TemperaturaAceite.Valida && (
              <Grid
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={4}
                item
                className="grid-item"
              >
                <MinMaxMedCard
                  icon={OilTemperatureIcon}
                  lang={lang}
                  title={lang.TemperaturaAceite}
                  units="°C"
                  minMaxMed={data.TemperaturaAceite}
                  inProp={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                />
              </Grid>
            )}
            {data.PresionAceite.Valida && (
              <Grid
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={4}
                item
                className="grid-item"
              >
                <MinMaxMedCard
                  icon={OilPresureIcon}
                  lang={lang}
                  title={lang.PresionAceite}
                  units="kPa"
                  minMaxMed={data.PresionAceite}
                  inProp={!isLoading}
                  delay={sequence.next()}
                  duration={duration}
                />
              </Grid>
            )}
          </Grid>
        </div>
      )}
      {hasData && (
        <div className="root" style={{ marginTop: "1.5rem" }}>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="grid-item"
            >
              <FilterTable
                data={errorCodes}
                lang={lang}
                columns={errorCodesColumns}
                defaultPageSize={
                  errorCodesColumns.length < 5 ? errorCodes.length : 5
                }
                filterable={true}
                tableHeader={lang.CodigosError}
                className="-striped -highlight borderless"
              />
            </Grid>
          </Grid>
        </div>
      )}
      <Dialog open={isConfigOpen} fullScreen transition={Transition}>
        <DialogTitle>
          <AppBar>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={closeConfiguration}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="title" color="inherit" className="flex">
                {lang.ConfigurarValores}
              </Typography>
            </Toolbar>
          </AppBar>
        </DialogTitle>
        <DialogContent>
          <div style={{ marginTop: "3rem" }} />
          <UnitsTable
            units={units}
            columns={[
              {
                Header: lang.Nombre,
                accessor: "Descripcion"
              },
              {
                Header: lang.VelocidadMotor,
                accessor: "RPM"
              },
              {
                Header: lang.Odometro,
                accessor: "Odometro"
              },
              {
                Header: lang.NivelCombustible,
                accessor: "PorcentajeCombustible"
              },
              {
                Header: lang.PosicionAcelerador,
                accessor: "PosicionAcelerador"
              },
              {
                Header: lang.TemperaturaAnticongelante,
                accessor: "TemperaturaAnticongelante"
              },
              {
                Header: lang.Horometro,
                accessor: "Horometro"
              }
            ]}
          />
          <div className="form-control-container">
            <Grid container justify="center" alignItems="center">
              <Grid
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                item
                className="grid-item"
              >
                <Grid
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  item
                  className="grid-item"
                >
                  <FormGroup col>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={selectedRanges.engineSpeed.active}
                          onChange={onChangeRangesCheck}
                          value="checkedB"
                          color="primary"
                          id={"engineSpeed"}
                        />
                      }
                      label={lang.VelocidadMotor}
                    />
                    <FormControl className="form-control">
                      <Input
                        id="engineSpeed"
                        type="number"
                        value={selectedRanges.engineSpeed.value}
                        onBlur={onBlurInputConfiguration}
                        onChange={onChangeRangesInputs}
                      />
                    </FormControl>
                  </FormGroup>
                </Grid>
                <Grid
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  item
                  className="grid-item"
                >
                  <FormGroup col>
                    <FormControlLabel
                      control={
                        <Switch
                          id="odometer"
                          checked={selectedRanges.odometer.active}
                          onChange={onChangeRangesCheck}
                          value="checkedB"
                          color="primary"
                        />
                      }
                      label={lang.Odometro}
                    />
                    <FormControl className="form-control">
                      <Input
                        id="odometer"
                        type="number"
                        value={selectedRanges.odometer.value}
                        onBlur={onBlurInputConfiguration}
                        onChange={onChangeRangesInputs}
                      />
                    </FormControl>
                  </FormGroup>
                </Grid>
                <Grid
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  item
                  className="grid-item"
                >
                  <FormGroup col>
                    <FormControlLabel
                      control={
                        <Switch
                          id="fuelLevel"
                          checked={selectedRanges.fuelLevel.active}
                          onChange={onChangeRangesCheck}
                          value="checkedB"
                          color="primary"
                        />
                      }
                      label={lang.NivelCombustible}
                    />
                    <FormControl className="form-control">
                      <Input
                        id="fuelLevel"
                        type="number"
                        value={selectedRanges.fuelLevel.value}
                        onBlur={onBlurInputConfiguration}
                        onChange={onChangeRangesInputs}
                      />
                    </FormControl>
                  </FormGroup>
                </Grid>
              </Grid>

              <Grid
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                item
                className="grid-item"
              >
                <Grid
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  item
                  className="grid-item"
                >
                  <FormGroup col>
                    <FormControlLabel
                      control={
                        <Switch
                          id="throttlePosition"
                          checked={selectedRanges.throttlePosition.active}
                          onChange={onChangeRangesCheck}
                          value="checkedB"
                          color="primary"
                        />
                      }
                      label={lang.PosicionAcelerador}
                    />
                    <FormControl className="form-control">
                      <Input
                        id="throttlePosition"
                        type="number"
                        value={selectedRanges.throttlePosition.value}
                        onBlur={onBlurInputConfiguration}
                        onChange={onChangeRangesInputs}
                      />
                    </FormControl>
                  </FormGroup>
                </Grid>
                <Grid
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  item
                  className="grid-item"
                >
                  <FormGroup col>
                    <FormControlLabel
                      control={
                        <Switch
                          id="antifreezeTemperature"
                          checked={selectedRanges.antifreezeTemperature.active}
                          onChange={onChangeRangesCheck}
                          value="checkedB"
                          color="primary"
                        />
                      }
                      label={lang.TemperaturaAnticongelante}
                    />
                    <FormControl className="form-control">
                      <Input
                        id="antifreezeTemperature"
                        type="number"
                        value={selectedRanges.antifreezeTemperature.value}
                        onBlur={onBlurInputConfiguration}
                        onChange={onChangeRangesInputs}
                      />
                    </FormControl>
                  </FormGroup>
                </Grid>
                <Grid
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  item
                  className="grid-item"
                >
                  <FormGroup col>
                    <FormControlLabel
                      control={
                        <Switch
                          id="hourmeter"
                          checked={selectedRanges.hourmeter.active}
                          onChange={onChangeRangesCheck}
                          value="checkedB"
                          color="primary"
                        />
                      }
                      label={lang.Horometro}
                    />
                    <FormControl className="form-control">
                      <Input
                        id="hourmeter"
                        type="number"
                        value={selectedRanges.hourmeter.value}
                        onBlur={onBlurInputConfiguration}
                        onChange={onChangeRangesInputs}
                      />
                    </FormControl>
                  </FormGroup>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="raised"
            size="small"
            onClick={resetConfigurationValues}
          >
            {lang.Restablecer}
          </Button>
          <Button
            color="primary"
            variant="raised"
            size="small"
            onClick={defaultConfigurationValues}
          >
            {lang.ValoresPorDefecto}
          </Button>
          <Button
            color="primary"
            variant="raised"
            onClick={saveConfiguration}
            size="small"
          >
            {lang.Guardar}
          </Button>
        </DialogActions>
      </Dialog>
      <AlertMessage
        open={isAlertMessageOpen}
        message={alertMessage}
        handleClose={handleCloseAlertMessage}
      />
    </div>
  );
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

export default ScanView;



// WEBPACK FOOTER //
// ./src/containers/Scan/ScanView.js